import GLightbox from 'glightbox';

document.querySelectorAll('[data-gallery]').forEach(galleryButton => {
    galleryButton.addEventListener('click', function(e){
        e.preventDefault();
        let items = JSON.parse(galleryButton.getAttribute('data-gallery-pictures'));

        let gallery = GLightbox({
            elements: items
        });

        gallery.open();
    });
});